import { UAParser } from 'ua-parser-js'

/**
 * iPadOS 13+ 的 Safari 默认「请求桌面版网站」，UA 伪装成 macOS，
 * ua-parser 会识别为 macOS 而非 iOS；真 Mac 没有触摸点，借此区分
 */
function isIPadDesktopUA(osName?: string) {
  return osName === 'macOS' && window.navigator.maxTouchPoints > 1
}

export async function getDeviceFeature() {
  const uap = new UAParser()
  const result = uap.getResult()
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const language = window.navigator.language

  let str = ''
  if (result.os.name === 'Android') {
    const androidRes = await uap.getResult()?.withClientHints()
    str = `#${androidRes.device.model}#${androidRes.device.type}#${androidRes.device.vendor}#${androidRes.os.name}#${timezone}#${language}`
  }
  else if (result.os.name === 'iOS') {
    str = `#${result.device.model}#${result.device.type}#${result.device.vendor}#${result.os.name}#${result.os.version}#${timezone}#${language}#${window.screen.width}#${window.screen.height}`
  }
  else if (isIPadDesktopUA(result.os.name)) {
    // 桌面 UA 拿不到真实机型和系统版本，按 iOS 口径回填可确定的信息
    str = `#iPad#tablet#Apple#iOS#${result.os.version}#${timezone}#${language}#${window.screen.width}#${window.screen.height}`
  }
  else {
    // PC 及其他平台（Windows/macOS/Linux/HarmonyOS 等）：沿用 iOS 分支的字段结构
    str = `#${result.device.model}#${result.device.type || 'desktop'}#${result.device.vendor}#${result.os.name}#${result.os.version}#${timezone}#${language}#${window.screen.width}#${window.screen.height}`
  }

  return str
}
